module.exports = __webpack_public_path__ + "static/media/qr-scan.b14bdfee.svg";